import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/ConsumptionMeteringPointGroupModal.module.scss';

import { OmaLummeApp } from '../../../omaLummeContext';

import Button from '../../Common/Button';
import Loading from '../../Common/Loading';
import ConsumptionMeteringPointGroupAccordion from './ConsumptionMeteringPointGroupAccordion';

import { closeMenuIconBlack } from '../../../icons';

import { putMeteringPointGroup } from '../../../actions';
import { MeteringPointGroupPut } from '../../../types/consumptionRates';

export type ConsumptionMeteringPointGroupNewProps = {
  setShowCreateModal: (value: React.SetStateAction<boolean>) => void;
  setRefreshData?: (value: React.SetStateAction<string>) => void;
};

const ConsumptionMeteringPointGroupNew: React.FunctionComponent<ConsumptionMeteringPointGroupNewProps> = (
  props: ConsumptionMeteringPointGroupNewProps,
) => {
  const { t } = useTranslation();
  const { users } = OmaLummeApp.useState();
  const { setShowCreateModal, setRefreshData } = props;

  const [groupName, setGroupName] = React.useState<string>('');
  const [meteringPoints, setMeteringPoints] = React.useState<MeteringPointGroupPut[]>([]);
  const [resetForm, setResetForm] = React.useState<boolean>(false);
  const [submitting, setSubmitting] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (resetForm) {
      setGroupName('');
      setMeteringPoints([]);
    }
  }, [resetForm]);

  const submitForm = async (): Promise<void> => {
    setSubmitting(true);
    const groupSubmitStatus = await putMeteringPointGroup(users.activeUser.userId, groupName, JSON.stringify(meteringPoints));
    setSubmitting(false);
    if (groupSubmitStatus === 200) {
      setShowCreateModal(false);
      setRefreshData && setRefreshData('groups');
    }
  };

  return (
    <div className={styles.modal}>
      <button className={styles.close} onClick={(): void => setShowCreateModal(false)}>
        <img src={closeMenuIconBlack} alt={t('common:general.close')} />
      </button>
      <h1 className={styles.title}>{t(`consumption:meteringPointGroup.createGroupTitle`)}</h1>
      <p className={styles.ingress}>{t(`consumption:meteringPointGroup.createGroupIngress`)}</p>

      <header className={styles.header}>
        <div>
          <label htmlFor="groupName">
            {t(`consumption:meteringPointGroup.groupNameInputTitle`)} {t('customerService:contactUs.requiredField')}
          </label>
          <input
            type="text"
            id="groupName"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            placeholder={t(`consumption:meteringPointGroup.groupNameInputPlaceholder`)}
          />
        </div>
        <div>
          {submitting && <Loading size="small" />}
          {!submitting && <Button onClick={() => submitForm()}>{t(`common:general.save`)}</Button>}
          <Button className="buttonWhite" onClick={() => setResetForm(true)}>
            {t(`common:general.cancel`)}
          </Button>
        </div>
      </header>

      <ConsumptionMeteringPointGroupAccordion type="create" user={users.parentUser} meteringPoints={{ meteringPoints, setMeteringPoints }} />
      {users.childUsers?.map((childUser) => (
        <ConsumptionMeteringPointGroupAccordion
          key={childUser.userId}
          type="create"
          user={childUser}
          meteringPoints={{ meteringPoints, setMeteringPoints }}
        />
      ))}
    </div>
  );
};

export default ConsumptionMeteringPointGroupNew;
